export const Role = {
  SuperAdmin: 'administrator',
  AdminGeneralCompany: 'admin general empresa',
  AdminLocalCompany: 'admin local',
  AdmissionsClerk: 'admissions clerk',
  Pharmacist: 'pharmacist',
  Nurse: 'nurse',
  Medic: 'medic',
  Lab: 'labtech',
  Patient: 'patient',
} as const;

export const RoleReverseMap = fromEntries(
  Object.entries(Role).map(([key, val]) => [val, key])
);

function fromEntries<T = any>(entries: [string, any][]): Record<string, T> {
  return entries.reduce((acc, [key, val]) => {
    acc[key] = val;
    return acc;
  }, {} as Record<string, T>);
}
